/**
 * Las dos rutas que no son de ningún módulo.
 *
 * Viven acá y no en `routes.tsx` porque quien las necesita —el formulario de
 * login, el cascarón, el menú de usuario— no puede importar el enrutador sin
 * arrastrar consigo todas las pantallas que éste carga en diferido, que es
 * justo lo que la carga en diferido existe para evitar.
 */

/** Correo y contraseña. Nunca una organización. */
export const LOGIN_PATH = '/login';

/**
 * A cuál organización entrar, cuando hay más de una.
 *
 * Ruta propia y no un paso adentro del login: es una pantalla con la sesión ya
 * abierta, así que recargarla tiene que seguir mostrando la lista y no pedir la
 * contraseña de nuevo. Un enlace a esta URL también es la forma de volver a
 * elegir sin cerrar sesión.
 */
export const TENANT_PICKER_PATH = '/elegir-organizacion';
